/**
 * erectionPlansApi — CR-2026-ERECTOR-E1 (2026-10-13). AISC 207-25 §5.12.6.
 * Server: src/routes/erectionPlans.js on the SFM Web Backend.
 */
import ApiCall from './apicall';

export const ERECTION_ELEMENT_KEYS = 'abcdefghijklmnopqrstu'.split('');
// CR-2026-ERECTOR-E1B: built-in form [Company]-QF-ER-002 Rev 0 safety items (server erectionPlans.js).
export const ERECTION_SAFETY_KEYS = ['sf_scope', 'sf_start', 'sf_coordination', 'sf_cranes', 'sf_fall_protection',
  'sf_falling_objects', 'sf_hazards', 'sf_emergency', 'sf_persons', 'sf_training'];
export const ERECTION_NO_NA = ['sf_fall_protection', 'sf_emergency', 'sf_persons', 'sf_training'];
export const QF_ER_002_DOCX = '/templates/osha-1926/QF-ER-002_Project-Specific_Erection_and_Safety_Plan_Rev0.docx';
export const QF_ER_002_PDF = '/templates/osha-1926/QF-ER-002_Project-Specific_Erection_and_Safety_Plan_Rev0.pdf';
/** A plan made on QF-ER-002 holds the safety items; an older plan keeps the 21 AISC elements. */
export const planOnTemplate = (elements) => ERECTION_SAFETY_KEYS.some((k) => elements && Object.prototype.hasOwnProperty.call(elements, k));
export const planKeys = (elements) => (planOnTemplate(elements) ? [...ERECTION_ELEMENT_KEYS, ...ERECTION_SAFETY_KEYS] : ERECTION_ELEMENT_KEYS);

export const ERECTION_STATUS_LABEL = {
  DRAFT: 'Draft',
  PM_REVIEWED: 'PM reviewed',
  RELEASED: 'Released',
  SUPERSEDED: 'Superseded',
};

export async function listErectionPlans(jobId) {
  const { data } = await ApiCall.get(`/erection-plans${jobId ? `?job_id=${jobId}` : ''}`);
  return data?.data?.plans || [];
}
export async function getErectionPlan(id) {
  const { data } = await ApiCall.get(`/erection-plans/${id}`);
  return data?.data;
}
export async function createErectionPlan(jobId) {
  const { data } = await ApiCall.post('/erection-plans', { job_id: Number(jobId) });
  return data?.data;
}
export async function updateErectionPlan(id, payload) {
  const { data } = await ApiCall.patch(`/erection-plans/${id}`, payload);
  return data?.data;
}
const action = (name) => async (id, body = {}) => {
  const { data } = await ApiCall.post(`/erection-plans/${id}/${name}`, body);
  return data?.data;
};
export const pmReviewErectionPlan = action('pm-review');
export const returnErectionPlan = action('return');
export const releaseErectionPlan = action('release');
export const reviseErectionPlan = action('revise');
export const distributeErectionPlan = action('distribute');

/** Mirrors the server rule: text, or N/A with a reason. */
export function unaddressedElements(elements) {
  return planKeys(elements).filter((k) => {
    const v = elements?.[k] || {};
    if (v.na) return ERECTION_NO_NA.includes(k) || !String(v.na_reason || '').trim();
    return !String(v.text || '').trim();
  });
}

export function apiMessage(err, fallback) {
  return err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;
}
